import React, { useEffect, useState } from 'react';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/survey-core.min.css';
import { surveyStorage } from '../services/surveyStorage';
import { surveyJson } from '../config/surveyConfig';

export default function OnboardingSurvey() {
  const [survey, setSurvey] = useState(null);

  useEffect(() => {
    // Create the survey model
    const newSurvey = new Model(surveyJson);
    
    // Load any previously saved responses
    const savedData = surveyStorage.loadResponses();
    if (savedData) {
      newSurvey.data = savedData;
    }

    // Save responses as the user fills out the survey
    newSurvey.onValueChanged.add((sender) => {
      surveyStorage.saveResponses(sender.data);
    });

    // Handle survey completion
    newSurvey.onComplete.add((sender) => {
      // Save final responses
      surveyStorage.saveResponses(sender.data);
      
      // Redirect to Devise signup page
      // Note: You may need to adjust this path based on your Devise configuration
      window.location.href = '/users/sign_up';
    });

    setSurvey(newSurvey);
  }, []);

  return (
    <div className="onboarding-survey-container">
      {survey && <Survey model={survey} />}
    </div>
  );
}

